module.exports = __webpack_public_path__ + "img/chilun.fabec722.png";